//Subscription below
export type SubscriptionProductPrice = {
	id: string
	createdAt?: string
	updatedAt?: string
	name: string
	currency: string
	amount: number
	trialAmount: number
	trialDays: number
	stripeId: string
	paypalId: string
	paypalSubscriptionPriceId: string
	productId?: string
	duration: number
	// Needed to init Stripe.js (loadStripe(price.stripePublicKey)) — was
	// missing here entirely; TS didn't catch it since `activeProduct` gets
	// `any`-poisoned by a JSON.parse() branch upstream (CheckoutPageClient.tsx).
	stripePublicKey?: string
	// The Stripe account's own country (price.providerAccount.countryCode in
	// PMS), needed by stripe.paymentRequest({ country }) for Google Pay. Only
	// meaningful when this price's provider is Stripe.
	stripeAccountCountry?: string
}

export enum DURATION_CONTEXT {
	DAYS = 'days',
	WEEKS = 'weeks',
	MONTHS = 'months',
	YEARS = 'years',
}

export type SubscriptionProductVariables = {
	currency: string
	currencySymbol: string
	titlePrice: string
	titlePriceFormatted: string
	trialPrice: number
	trialPriceFormatted: string
	trialDuration: number
	trialContext: `${DURATION_CONTEXT}`
	regularPrice: number
	regularPriceFormatted: string
	regularDuration: number
	regularContext: `${DURATION_CONTEXT}`
	compareAtPrice: number
	compareAtPriceFormatted: string
	discountPercentage: number
}

export type SubscriptionProduct = {
	id: string
	name: string
	createdAt?: string
	updatedAt?: string
	description: string
	priceTitle: string
	sku: string
	isDefault?: boolean
	campaign?: string
	isFavourite: boolean
	price: SubscriptionProductPrice
	priceNumber: number
	priceDecimal: number
	productVariables: SubscriptionProductVariables
	recurrentName: string
	applePayDisabled?: boolean
	googlePayDisabled?: boolean
}

export type Currency = {
	isDefault: boolean
	symbol: string
	code: string
}
